import React, { useContext, useEffect } from "react";
import HeartToSoul from "../../../../Assets/Images/HeartToSoul.png";
import heartToSoul2 from "../../../../Assets/Images/HeartToSoul2.png";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import HeartIcon from "../../../../Assets/Images/Heart-Icon.png";
import MindIcon from "../../../../Assets/Images/MIND.png";
import StrengthIcon from "../../../../Assets/Images/STRENGTH.png";
import SoulIcon from "../../../../Assets/Images/SOUL.png";
import ArrowRight from "../../../../Assets/Images/arrow-right.png";
import GroupReportContext from "../../../../Context/GroupReportContext";
import flow_HM from "../../../../Assets/Images/flowScoreIcons/H-M.png";
import flow_HS from "../../../../Assets/Images/flowScoreIcons/H-S.png";
import flow_HST from "../../../../Assets/Images/flowScoreIcons/H-ST.png";
import flow_MH from "../../../../Assets/Images/flowScoreIcons/M-H.png";
import flow_MS from "../../../../Assets/Images/flowScoreIcons/M-S.png";
import flow_MST from "../../../../Assets/Images/flowScoreIcons/M-ST.png";
import flow_SH from "../../../../Assets/Images/flowScoreIcons/S-H.png";
import flow_SM from "../../../../Assets/Images/flowScoreIcons/S-M.png";
import flow_SST from "../../../../Assets/Images/flowScoreIcons/S-ST.png";
import flow_STH from "../../../../Assets/Images/flowScoreIcons/ST-H.png";
import flow_STM from "../../../../Assets/Images/flowScoreIcons/ST-M.png";
import flow_STS from "../../../../Assets/Images/flowScoreIcons/ST-S.png";
import { fetchGroupReportPreviewData } from "../../../../api";
import { getPotentialStrengths, getPotentialWeakness, getPotentialWeaknessParagraphs } from "./DynamicContentHeartToSoul";
import { applyFullTieOrder } from "../../../../utils/quadrantTieOrder";

// Hierarchy for tie-breaking: lower number = higher priority
const QUADRANT_HIERARCHY = {
  heart: 0,      // Highest priority
  soul: 1,
  mind: 2,
  strength: 3    // Lowest priority
};

// Comparator function for sorting quadrants with tie-breaking
const compareQuadrants = (a, b) => {
  // First compare by avg/value (descending)
  const valueDiff = (b.avg ?? b.value ?? 0) - (a.avg ?? a.value ?? 0);
  if (valueDiff !== 0) return valueDiff;
  
  // If values are equal, compare by hierarchy (ascending - lower number = higher priority)
  const aHierarchy = QUADRANT_HIERARCHY[a.name?.toLowerCase()] ?? 999;
  const bHierarchy = QUADRANT_HIERARCHY[b.name?.toLowerCase()] ?? 999;
  return aHierarchy - bHierarchy;
};

export default function HeartToSoulFirstGroup({ apiData, previewData, reportType, pageNumber }) {
  const groupReportCtx = useContext(GroupReportContext);

  // Sort averages (desc) to get ranking

  const priorityOrder = {
    Heart: 0,
    Soul: 1,
    Mind: 2,
    Strength: 3,
  };

  // const avgPercenatges = groupReportCtx?.averagePercentages
  //   ? [...groupReportCtx.averagePercentages].sort((a, b) => b.avg - a.avg)
  //   : [];

  const avgPercenatges = groupReportCtx?.averagePercentages
    ? applyFullTieOrder([...groupReportCtx.averagePercentages].sort(compareQuadrants), (q) => q.name, (q) => q.avg)
    : [];

  console.log("avgPercenatges", avgPercenatges)

  // Build score ranking safely
  const scoreRanking = [
    { name: avgPercenatges?.[0]?.name, value: avgPercenatges?.[0]?.avg },
    { name: avgPercenatges?.[1]?.name, value: avgPercenatges?.[1]?.avg },
    { name: avgPercenatges?.[2]?.name, value: avgPercenatges?.[2]?.avg },
    { name: avgPercenatges?.[3]?.name, value: avgPercenatges?.[3]?.avg },
  ].filter(x => x?.name);

  // ---- DYNAMIC HEADING (TOP TWO QUADRANTS) ----
  const top1 = scoreRanking?.[0]?.name;
  const top2 = scoreRanking?.[1]?.name;
  const flowHead = top1 && top2 ? `${top1.toUpperCase()} TO ${top2.toUpperCase()}` : "GROUP FLOW";
  const tagline = () => {
    if (flowHead == "HEART TO SOUL") {
      return "Feels good. But why?"
    }
    else if (flowHead == "HEART TO MIND") {
      return "Feels good; I need to understand."
    }
    else if (flowHead == "HEART TO STRENGTH") {
      return "Feels good. Let’s go!"
    }
    else if (flowHead == "SOUL TO MIND") {
      return " This is meaningful; let’s design it."
    }
    else if (flowHead == "SOUL TO STRENGTH") {
      return " This is meaningful; let’s do something."
    }
    else if (flowHead == "SOUL TO HEART") {
      return "This is meaningful; let’s feel it."
    }
    else if (flowHead == "MIND TO STRENGTH") {
      return "Makes sense; let’s go!"
    }
    else if (flowHead == "MIND TO HEART") {
      return "Makes sense, who do I need?"
    }
    else if (flowHead == "MIND TO SOUL") {
      return "Makes sense, but why?"
    }
    else if (flowHead == "STRENGTH TO SOUL") {
      return "I’m doing this, but why?"
    }
    else if (flowHead == "STRENGTH TO MIND") {
      return "I’m doing this. How can it be better?"
    }
    else if (flowHead == "STRENGTH TO HEART") {
      return "I’m doing this. Who’s in?"
    }
    return "Feels good. But why?"
  };

  // (Optional) Archetype helpers kept as-is if used later
  const ArchtypeOne = (flowHead) => {
    if (flowHead === "Heart") return "Heart-Centered Leader";
    if (flowHead === "Mind") return "Mind-Driven Strategist";
    if (flowHead === "Strength") return "Strength-Based Leader";
    if (flowHead === "Soul") return "Soul-Inspired Visionary";
    return "Unknown Archetype";
  };
  const ArchtypeTwo = (flowHead) => {
    if (flowHead === "Heart") return "Mind-Driven Strategist";
    if (flowHead === "Mind") return "Strength-Based Leader";
    if (flowHead === "Strength") return "Soul-Inspired Visionary";
    if (flowHead === "Soul") return "Heart-Centered Leader";
    return "Unknown Archetype";
  };
  const ArchtypeThree = (flowHead) => {
    if (flowHead === "Heart") return "Strength-Based Leader";
    if (flowHead === "Mind") return "Soul-Inspired Visionary";
    if (flowHead === "Strength") return "Heart-Centered Leader";
    if (flowHead === "Soul") return "Mind-Driven Strategist";
    return "Unknown Archetype";
  };
  const ArchtypeFour = (flowHead) => {
    if (flowHead === "Heart") return "Soul-Inspired Visionary";
    if (flowHead === "Mind") return "Heart-Centered Leader";
    if (flowHead === "Strength") return "Mind-Driven Strategist";
    if (flowHead === "Soul") return "Strength-Based Leader";
    return "Unknown Archetype";
  };
  const ArchtypeFive = (flowHead) => {
    if (flowHead === "Heart") return "Mind-Driven Strategist";
    if (flowHead === "Mind") return "Soul-Inspired Visionary";
    if (flowHead === "Strength") return "Heart-Centered Leader";
    if (flowHead === "Soul") return "Strength-Based Leader";
    return "Unknown Archetype";
  };
  const ArchtypeSix = (flowHead) => {
    if (flowHead === "Heart") return "Strength-Based Leader";
    if (flowHead === "Mind") return "Heart-Centered Leader";
    if (flowHead === "Strength") return "Mind-Driven Strategist";
    if (flowHead === "Soul") return "Soul-Inspired Visionary";
    return "Unknown Archetype";
  };

  const styles = {
    coverSection: {
      display: "flex",
      flexDirection: "column",
      fontFamily: "Helvetica, sans-serif",
      padding: "16px 0px",
      color: "#000000",
    },
    maincontent: {
      fontWeight: 700,
      fontSize: "16px",
      lineHeight: "24px",
      color: "#426B88",
      marginBottom: "7px",
    },
    topSection: {
      display: "flex",
      gap: "16px",
      width: "100%",
      alignItems: "flex-start",
      // flexWrap: "wrap",
      marginBottom: "16px",

    },
    coverTitle: {
      fontSize: "10px",
      fontWeight: 700,
      lineHeight: "14px",
      color: "#000000",
      textTransform: "uppercase",

    },
    contentContainer: {
      width: "50%",
      maxWidth: "32ch"

    },
    paragraph: {
      fontWeight: 400,
      fontSize: "10px",
      lineHeight: "14px",
      color: "#000000",
      margin: "0px",
      paddingBottom: "16px",
    },
    paragraphFirst: {
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "19px",
      color: "#245775",
      marginBottom: "10px",
      marginTop: "29px",
    },
    paragraphLast: {
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "19px",
      color: "#245775",
      marginBottom: 0,
    },
    highlightText: {
      fontSize: "10px",
      fontWeight: 700,
      lineHeight: "14px",
      color: "#000000",
      margin: "10px 0px 16px",
    },
    coverImage: {
      width: "108px",
    },
    textContent: {
      display: "flex",
      justifyContent: "space-between",
      width: "100%"
    },
    pointsContainer: {
      margin: "0px",
      width: "50%",
      maxWidth: "30ch"

    },
    pointsHeader: {
      fontWeight: 700,
      fontSize: "10px",
      color: "#000000",
      lineHeight: "14px",
      marginBottom: "4px",
    },
    pointText: {
      fontWeight: 400,
      fontSize: "10px",
      color: "#000000",
      lineHeight: "14px",
      marginBottom: "4px",
      paddingLeft: "10px",
      textIndent: "-7px",

    },
    bottomSection: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "20px",
    },
    bottomImage: {
      width: "80%",
      objectFit: "contain",
    },
    noteContainer: {
      marginTop: "20px",
      padding: "0 10%",
      textAlign: "center",
    },
    noteBold: {
      fontSize: "12px",
      fontWeight: 700,
      color: "#245775",
    },
    noteText: {
      fontSize: "12px",
      fontWeight: 400,
      color: "#426B88",
      lineHeight: "20px",
      letterSpacing: "0px",
    },
    chartHeading: {
      textAlign: "center",
      marginTop: "38px",
      marginBottom: "15px",
      fontFamily: "Helvetica",
      fontWeight: 700,
      fontStyle: "normal",
      fontSize: "8px",
      lineHeight: "12px",
      letterSpacing: "0%",
      color: "#000000",
      verticalAlign: "middle",
      leadingTrim: "cap-height",
    },
  };

  useEffect(() => {
    (async () => {
      try {
        const preview = await fetchGroupReportPreviewData();
        groupReportCtx?.setPreviewData(preview?.data);
      } catch (error) {
        console.error("Error fetching preview data:", error);
      }
    })();
  }, []);

  const getFlowImage = () => {
    const images = {
      HS: flow_HS,
      HM: flow_HM,
      HST: flow_HST,
      MH: flow_MH,
      MS: flow_MS,
      MST: flow_MST,
      SH: flow_SH,
      SM: flow_SM,
      SST: flow_SST,
      STH: flow_STH,
      STM: flow_STM,
      STS: flow_STS,
    };
    const first = scoreRanking?.[0]?.name;
    const second = scoreRanking?.[1]?.name;
    const map = { Heart: "H", Mind: "M", Soul: "S", Strength: "ST" };
    const key = `${map[first] || ""}${map[second] || ""}`;
    return images[key] || HeartToSoul;
  };

  const imagesMap = {
    Soul: { icon: SoulIcon, label: "Soul" },
    Heart: { icon: HeartIcon, label: "Heart" },
    Mind: { icon: MindIcon, label: "Mind" },
    Strength: { icon: StrengthIcon, label: "Strength" },
  };
  const sortedScores = applyFullTieOrder([...scoreRanking].sort(compareQuadrants), (q) => q.name, (q) => q.value);

  const sortedImages = sortedScores.map(item => imagesMap[item.name]);



  const baseSize = 88;
  const sizeDecrement = 30;
  const sizeSequence = [88, 64, 50, 28];
  const minSize = sizeSequence[sizeSequence.length - 1];
  const imageSizes = sortedImages.map((_, index) =>
    sizeSequence[index] || Math.max(minSize, baseSize - index * sizeDecrement)
  );
  const itemWidth = Math.max(...imageSizes) + 20;


  const Arrow = () => (
    <svg width="70" height="28" viewBox="0 0 70 28" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ verticalAlign: 'middle' }}>
      <line x1="0" y1="12" x2="70" y2="12" stroke="#245775" strokeWidth="3.6" />
      <path d="M30 3L40 12L30 21" fill="none" stroke="#245775" strokeWidth="3.6" />
    </svg>

  );

  return (
    <div>
      <HeaderPreview />
      <div style={styles.coverSection}>
        <div style={styles.coverTitle}>{flowHead} GROUPS</div>
        <div style={styles.highlightText}>{tagline()}</div>

        <div style={styles.topSection}>
          <img src={getFlowImage()} style={styles.coverImage} />
          <div style={styles.textContent}>
            {getPotentialStrengths(flowHead, styles)}
            {getPotentialWeakness(flowHead, styles)}
          </div>
        </div>
        {getPotentialWeaknessParagraphs(flowHead, styles)}

        <div style={{ width: '100%', marginTop: "16px" }}>
          <div style={{
            position: "relative",
            paddingTop: "16px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            maxWidth: "411px",
            margin: "0px auto"
          }}>
            <p style={{
              position: "absolute",
              left: "10%",
              transform: "translateX(-50%)",
              top: "0",
              fontSize: '11px',
              fontWeight: 700,
              color: '#245775',
              fontFamily: 'Helvetica',
              margin: 0,
              marginBottom: '8px'
            }}>Start</p>
            <div style={{
              width: "100%",
              maxWidth: "411px",
              display: 'flex',
              flexDirection: "row",
              gap: "57px",
              alignItems: "center",
              justifyContent: "center"
            }}>
              {sortedImages.map((item, index) => (
                <div key={index} style={{
                  display: 'flex',
                  flexDirection: "column",
                  alignItems: "center",
                  position: "relative",
                  width: `${itemWidth}px`,
                }}>
                  <img
                    src={item.icon}
                    alt={item.label}
                    style={{ width: `${imageSizes[index]}px`, height: `${imageSizes[index]}px`, zIndex: "999" }}
                  />

                  {index < sortedImages.length - 1 && (
                    <div style={{
                      position: "absolute",
                      top: `${imageSizes[index] / 2}px`,
                      left: index === 0
                        ? "87px"
                        : index === 1
                          ? "62.5px"
                          : index === 2
                            ? "49px"
                            : "0px",
                      width: index == 2
                        ? "82px" : "74px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}>
                      <span style={{
                        position: "absolute",
                        fontSize: 50,
                        fontWeight: 300,
                        top: -29.5,
                        left: 0,
                        color: "#245775",
                        fontFamily: 'Helvetica'
                      }}>
                        <Arrow />
                      </span>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div style={{
              width: "100%",
              display: 'flex',
              flexDirection: "row",
              gap: "60px",
              alignItems: "center",
              justifyContent: "start"
            }}>
              {sortedImages.map((item, index) => (
                <div key={index} style={{
                  display: 'flex',
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  position: "relative",
                  width: `${imageSizes[index]}px`,
                }}>
                  <div style={{
                    marginTop: '8px',
                    textAlign: 'center',
                    width: `${imageSizes[index]}px`,
                    minWidth: "fit-content",
                  }}>
                    <p style={{
                      margin: 0,
                      lineHeight: '18px',
                      fontWeight: 700,
                      fontSize: '11px',
                      color: '#245775',
                      fontFamily: 'Helvetica'
                    }}>{item.label}</p>
                    <p style={{
                      margin: 0,
                      fontSize: '11px',
                      color: '#5795B2',
                      fontWeight: 400,
                      textAlign: 'center',
                      lineHeight: '18px',
                      fontFamily: 'Helvetica'
                    }}>{typeof sortedScores[index].value === 'number' ? parseFloat(sortedScores[index].value)?.toFixed(2) : parseFloat(sortedScores[index].value).toFixed(2)}%</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>


      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
}
